import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import moment from 'moment';
import { subscribeToTruck, unsubscribeFromTruck } from '../../utils/truckHub';

// Sydney — a sensible default centre before we've heard a position for the truck.
const DEFAULT_CENTER = { lat: -33.8688, lng: 151.2093 };

const LiveGoogleMap = withGoogleMap(props => (
    <GoogleMap
        defaultZoom={15}
        center={props.center}
        options={{ fullscreenControl: true, streetViewControl: false, mapTypeControl: false }}
    >
        {props.position && <Marker position={props.position} title={props.title} />}
    </GoogleMap>
));

class TruckLocationMap extends React.Component {
    componentDidMount() {
        if (this.props.numberPlate) {
            subscribeToTruck(this.props.numberPlate);
        }
    }

    componentDidUpdate(prevProps) {
        // subscribeToTruck unsubscribes the previous plate itself when it changes.
        if (prevProps.numberPlate !== this.props.numberPlate && this.props.numberPlate) {
            subscribeToTruck(this.props.numberPlate);
        }
    }

    componentWillUnmount() {
        if (this.props.numberPlate) {
            unsubscribeFromTruck(this.props.numberPlate);
        }
    }

    // The truckData slice is shared; only trust the location if it's actually for this truck
    // (a plate switch can briefly leave the previous truck's cached position in the store).
    matchedLocation() {
        const { location, numberPlate } = this.props;
        if (location && location.truckNumberPlate && numberPlate
            && location.truckNumberPlate.toLowerCase() === numberPlate.toLowerCase()
            && (location.latitude || location.longitude)) {
            return location;
        }
        return null;
    }

    renderStatus(location) {
        const { connected } = this.props;
        if (location) {
            const when = location.timestamp ? moment(location.timestamp).fromNow() : 'just now';
            return (
                <span>
                    <i className={connected ? 'fa fa-circle text-success' : 'fa fa-circle text-muted'} />
                    &nbsp;{connected ? 'Live position' : 'Last known position (truck offline)'} — updated {when}
                </span>
            );
        }
        return (
            <span>
                <i className={connected ? 'fa fa-circle text-success' : 'fa fa-circle text-muted'} />
                &nbsp;{connected ? 'Connected — waiting for GPS…' : 'Truck offline — no position reported yet'}
            </span>
        );
    }

    render() {
        const location = this.matchedLocation();
        const position = location ? { lat: location.latitude, lng: location.longitude } : null;
        const center = position || DEFAULT_CENTER;

        return (
            <div>
                <div className="mb-1">{this.renderStatus(location)}</div>
                <LiveGoogleMap
                    loadingElement={<div style={{ height: '100%' }} />}
                    containerElement={<div style={{ height: '400px' }} />}
                    mapElement={<div style={{ height: '100%' }} />}
                    center={center}
                    position={position}
                    title={this.props.numberPlate}
                />
            </div>
        );
    }
}

TruckLocationMap.propTypes = {
    numberPlate: PropTypes.string,
    location: PropTypes.object,
    connected: PropTypes.bool,
};

function mapStateToProps(state) {
    return {
        location: state.truckData.location,
        connected: state.truckData.connected,
    };
}

export default connect(mapStateToProps)(TruckLocationMap);
